/**
 * Meta descriptions are truncated by Google at roughly 155–160 characters. Cut
 * them ourselves, on a word boundary, so the snippet ends in a whole word
 * instead of Google's mid-word ellipsis.
 */
export function clampDescription(text: string | null | undefined, max = 160): string {
  const normalized = (text ?? '').replace(/\s+/g, ' ').trim();
  if (normalized.length <= max) return normalized;

  // -1 leaves room for the ellipsis.
  const cut = normalized.slice(0, max - 1);
  const lastSpace = cut.lastIndexOf(' ');
  const body = lastSpace > max * 0.6 ? cut.slice(0, lastSpace) : cut;
  return `${body.replace(/[\s,;:.!?—–-]+$/, '')}…`;
}
